import React, { Fragment }  from 'react';
import { Container, Alert, Button }  from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';


function CovidScreen () {
    return (
        <Fragment>
            <Head titulo="Dispensas emergenciais feitas durante a pandemia de COVID-19 no Município de Macuco"/>
            <Header />
            <Container>
                <h5>Dispensas Emergenciais</h5>
                <Alert variant='danger'>Até a presente data não teve deflagração de processo por dispensa 
                baseada na Lei Federal n. 13.979/2020</Alert>
                <br/>
                <Link to={'/licitacao/covid'}>
                    <Button variant='primary'>Ir para Licitações realizadas durante a pandemia de COVID-19</Button>
                </Link>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CovidScreen;